
import { instance } from "../network/ApiCall";

export async function GetCategoryAPI() {
  const Response = await instance.get("/materialCategory/getAllMaterialCatergory");
  return Response.data;
}

export async function AddCategoryAPI(data: any) {
  const Response = await instance.post("/materialCategory/addMaterialCatergory", data);
  return Response.data;
}

export async function UpdateCategoryAPI(data: any) {
  const Response = await instance.put("/materialCategory/editMaterialCatergory", data);
  return Response.data;
}
